/**
 * Aquaculture (Lobster) Industry Configuration — minimal stub (2026-06-27).
 *
 * Full configuration lives DB-side (industry_profiles + dynamic card registry).
 * This stub gives the picker a name + icon + sensible asset types so the new
 * vertical is discoverable in the UI even before the backend dynamic load
 * arrives.
 */

import { IndustryConfig } from '../industryTypes'

export const aquacultureLobsterConfig: IndustryConfig = {
  id: 'aquaculture_lobster',
  name: 'Aquaculture (Lobster)',
  description: 'Lobster RAS + nearshore cages — BiologyBridge, BAP RAS / OIE Ch.1.4 / EU 853/2004',
  icon: 'Fish',

  terminology: {
    asset: 'Tank / Cage',
    assets: 'Tanks / Cages',
    assetPlural: 'Tanks / Cages',
    assetType: 'Aquaculture System',
    failure: 'Mortality Event',
    health: 'Stock Health',
    healthScore: 'Welfare Score',
    healthy: 'Healthy',
    degraded: 'Stressed',
    critical: 'Mass Mortality Risk',
    alert: 'Welfare Alert',
    process: 'Biology Process',
    maintenance: 'System Maintenance',
    inspection: 'Stock Inspection',
    downtime: 'Service Interruption',
    workOrder: 'Work Order',
    prediction: 'Biology Forecast',
    anomaly: 'Welfare Anomaly',
    trend: 'Growth Trend',
    risk: 'Mortality Risk',
    facility: 'RAS Facility',
    facilityPlural: 'RAS Facilities',
    location: 'Tank / Loop',
    operator: 'Aquaculture Technician',
    supervisor: 'Site Manager',
    calibration: 'Probe Calibration',
    compliance: 'Aquaculture Compliance',
  },

  assetTypes: [
    { id: 'ras_tank', name: 'RAS Tank', category: 'tank' },
    { id: 'biofilter_mbbr', name: 'Biofilter (MBBR)', category: 'water_treatment' },
    { id: 'uv_sterilizer', name: 'UV Sterilizer', category: 'water_treatment' },
    { id: 'ozone_reactor', name: 'Ozone Reactor', category: 'water_treatment' },
    { id: 'cage_nearshore', name: 'Nearshore Cage', category: 'cage' },
    { id: 'live_holding_tank', name: 'Live-Holding Tank', category: 'cold_chain' },
    { id: 'cold_chain_shipment', name: 'Cold-Chain Shipment', category: 'logistics' },
  ] as any,

  complianceStandards: [
    { id: 'bap_ras', name: 'BAP RAS Standard', authority: 'Best Aquaculture Practices' },
    { id: 'oie_ch_1_4', name: 'OIE Aquatic Animal Health Code Ch. 1.4', authority: 'WOAH' },
    { id: 'msc', name: 'Marine Stewardship Council', authority: 'MSC' },
    { id: 'eu_853_2004', name: 'EU 853/2004 (food of animal origin)', authority: 'European Union' },
    { id: '21_cfr_123', name: '21 CFR 123 (Seafood HACCP)', authority: 'US FDA' },
    { id: 'norwegian_aquaculture_act', name: 'Norwegian Aquaculture Act', authority: 'Mattilsynet' },
  ] as any,
} as IndustryConfig

export default aquacultureLobsterConfig
